import { localize } from "@gtmhub/localization";
import { IOkrGridColumn } from "./models";

export const localizeGridColName = function () {
  return function (column: IOkrGridColumn): string {
    if (column.isCustom) {
      return column.label;
    }
    // enriching column field with prefix to generate unique keys for column fields
    // column fields are used as keys to get column labels
    const keyToFind: string = "grid_col_" + column.field;

    return localize(keyToFind) ? localize(keyToFind) : column.label;
  };
};
